import { Component, Input, OnInit, inject } from "@angular/core";
import { finalize } from "rxjs/operators";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import {
  AddressLookupIncludes,
  AnlageDetailDto,
  AnlageStammdatenDetailDto,
  BeneficiaryDto,
  BeneficiaryDtoIncludFlags,
  ContractAddressesClientProvider,
  KundenClientProvider,
  KundenLookupDto,
  MonitoringStatusDto,
} from "src/app/web-api/web-api";
import { FacilityMasterDataComponent } from "../facility-masterdata/facility-masterdata.component";
import { UserService } from "src/app/services/user.service";

@Component({
    selector: "facility-overview",
    templateUrl: "./facility-overview.component.html",
    styleUrls: ["./facility-overview.component.scss"],
    standalone: false
})
export class FacilityOverviewComponent implements OnInit {
  private _popupService = inject(CstResponsivePopupService);
  private _kundenClient = inject(KundenClientProvider);
  private _contractAddressClient = inject(ContractAddressesClientProvider);
  private _userService = inject(UserService);

  private _facility: AnlageDetailDto = null;
  @Input() public set facility(value: AnlageDetailDto) {
    this._facility = value;
    this.refresh();
  }
  public get facility() {
    return this._facility;
  }
  public get userIsExternal() {
return !this._userService.CurrentUser.internalAccess;
  }
  @Input() monitoringStatus: MonitoringStatusDto;

  public eyeCatcher: Array<AnlageStammdatenDetailDto> =
    new Array<AnlageStammdatenDetailDto>();
  public maxEyecatcherLabelLength = 0;

  public customer: KundenLookupDto;
  public customerIsLoading = false;

  public beneficiaries: BeneficiaryDto[] = null;
  public beneficiaryIsLoading = false;

  ngOnInit(): void {
    this.maxEyecatcherLabelLength += 2;
  }

  public interpreteMasterDataValue(value: string): string {
    return value ? value : "kein Eintrag";
  }

  public showMasterData() {
    if (!this._facility) {
      return;
    }
    this._popupService.open(FacilityMasterDataComponent, {
      data: this.facility,
    });
  }

  public refresh() {
    if (!this._facility) {
      return;
    }
    this.eyeCatcher = [];
    if (this._facility.stammdaten) {
      this._facility.stammdaten.forEach((element) => {
        if (element.xmlConfig?.includes('"IsEyeCatching" Value="True"')) {
          this.maxEyecatcherLabelLength =
            this.maxEyecatcherLabelLength < element.label?.length
              ? element.label?.length
              : this.maxEyecatcherLabelLength;
          this.eyeCatcher.push(element);
        }
      });
    }
    if (this._facility.anlageID) {
      this.customerIsLoading = true;
      this._kundenClient
        .getAll(AddressLookupIncludes.None, null, this._facility.anlageID)
        .pipe(finalize(() => (this.customerIsLoading = false)))
        .subscribe((r) => {
          this.customer = r.data[0];
        });
    }
    if (this._facility.anlageID && !this.userIsExternal) {
      this.beneficiaryIsLoading = true;
      this._contractAddressClient
        .getBeneficiariesForFacilityIDs(BeneficiaryDtoIncludFlags.AddressLine, [
          this._facility.anlageID,
        ])
        .pipe(finalize(() => (this.beneficiaryIsLoading = false)))
        .subscribe((r) => (this.beneficiaries = r));
    }
  }
}
